import { canMeasureMarketing, subscribeConsent } from '../measurement/consent';
import { vendorUrlIsSafe } from '../measurement/measurementCore';
import { startMetaIdentifierCollection } from './metaIdentifiers';
import { sendMetaPageViewToConversionsApi } from './metaPixel';
type Pixel = ((...args: unknown[]) => void) & { queue?: unknown[][]; callMethod?: (...args: unknown[]) => void; push?: Pixel; loaded?: boolean; version?: string };
const target = window as unknown as { fbq?: Pixel; _fbq?: Pixel };
let initialized = false;
function sync() {
  if (!canMeasureMarketing()) { target.fbq?.('consent', 'revoke'); if (target.fbq?.queue) target.fbq.queue.length = 0; return; }
  startMetaIdentifierCollection();
  if (!vendorUrlIsSafe(location.href, document.referrer)) return;
  if (initialized) { target.fbq?.('consent', 'grant'); return; }
  initialized = true;
  const pixel: Pixel = function(...args) { if (!canMeasureMarketing() && args[0] !== 'consent') return; if (pixel.callMethod) pixel.callMethod(...args); else pixel.queue!.push(args); };
  pixel.queue = []; pixel.push = pixel; pixel.loaded = true; pixel.version = '2.0';
  target.fbq = target._fbq = pixel;
  pixel('consent', 'grant'); pixel('init', '2185878898915213');
  // Disable form/automatic advanced matching; collect only named explicit events.
  pixel('set', 'autoConfig', false, '2185878898915213');
  const eventId = crypto.randomUUID();
  pixel('track', 'PageView', {}, {eventID: eventId});
  sendMetaPageViewToConversionsApi(eventId);
  const script = document.createElement('script'); script.async = true; script.src = 'https://connect.facebook.net/en_US/fbevents.js'; document.head.appendChild(script);
}
export function startMetaConsent() { subscribeConsent(sync); sync(); }
